import { render, staticRenderFns } from "./DropDownStudentsGroups.vue?vue&type=template&id=7e3dbd87&scoped=true"
import script from "./DropDownStudentsGroups.vue?vue&type=script&lang=js"
export * from "./DropDownStudentsGroups.vue?vue&type=script&lang=js"
import style0 from "./DropDownStudentsGroups.vue?vue&type=style&index=0&id=7e3dbd87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3dbd87",
  null
  
)

export default component.exports